import { lazy } from 'react';


export const BinanceScenario = lazy(() => import('./BinanceScenario'));
